'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('voter-group-list', {
      url: '/voter-group/list',
      template: '<voter-group-list></voter-group-list>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/portfolio/voter-group-list/voter-group-list.routes.js